export const STATUS_UPLOADING = 'STATUS_UPLOADING';
export const STATUS_SUCCESS = 'STATUS_SUCCESS';
export const STATUS_FAILURE = 'STATUS_FAILURE';

export const createUid = () => {
    return Math.random().toString(36).substr(2, 9);
};

export default function FileEntity(source) {
    return {
        uid: createUid(),
        name: undefined,
        originalName: source.name,
        source: source,
        status: STATUS_UPLOADING,
        message: undefined,
    }
};